export default "__VITE_ASSET__Dcu2L2Rc__"